import styled, { Breakpoint, Font, Spacing } from '@nfinite/react-hubstairs/styled'
import Button from 'components/Commons/Button'

export const Container = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${Spacing.generatePadding({ top: 'xxl' })}
`

export const HugeMessage = styled('div')`
  font-size: 86px;
  ${Font.generate({ weight: 'bold' })}
  ${Spacing.generateMargin({ bottom: 'xxl' })}
`

export const StyledButton = styled(Button)`
  ${Spacing.generateMargin({ top: 'xl', horizontal: 'auto' })}

  ${Breakpoint.greaterOrEqualThan('sm')} {
    ${Spacing.generateMargin({ horizontal: '0' })}
  }
`
